export const translateCondition = (value) => {
  const map = {
    equals: "=",
    "not-equals": "!=",
    contains: "contains",
    "not-contains": "not contains",
    "greater-than": ">",
    "less-than": "<",
    "greater-than-or-equal": ">=",
    "less-than-or-equal": "<=",
  };

  // Return the mapped value or an empty string if it doesn't exist
  return map[value];
};
